import { render, staticRenderFns } from "./SiteAdminForm.vue?vue&type=template&id=79066de2"
import script from "./SiteAdminForm.vue?vue&type=script&lang=ts"
export * from "./SiteAdminForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports